export default function History() {
  return (
    <div className="w-full">
      <div className="container mx-auto p-3 flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-3">
        <div className="lg:w-3/12 w-full">
          <p className="text-[28px] font-semibold text-[#033F6A] w-[350px] lg:text-[36px] lg:w-[220px]">
            Lịch sử hình thành & phát triển
          </p>
        </div>
        <div className="lg:w-9/12 w-full bg-white shadow-custom rounded-lg px-6 py-6 border border-solid border-[#E2E2E2] ">
          <div className="relative">
            <div className="absolute top-0 left-10 transform -translate-x-1/2 w-0.5 h-full bg-[#1c9bdb]"></div>

            {[
              {
                year: "2024",
                text: [
                  "Thương hiệu KeyAvo – Nhận giải thưởng TOP 10 thương hiệu uy tín năm 2024",
                  "Thương hiệu Blue Rise – Nhận giải thưởng TOP 10 sáng kiến ngành giáo dục năm 2024",
                ],
              },
              {
                year: "2023",
                text: "Khảo sát và nghiên cứu phát triển hệ thống quản lý giáo dục Blue Rise",
              },
              {
                year: "2022",
                text: "Ra mắt học viên giáo dục Bigmax Academy",
              },
              {
                year: "2021",
                text: "Ra mắt thị trường sản phẩm nông sản sạch dầu bơ ép lạnh thượng hạng KeyAvo",
              },
              {
                year: "2020",
                text: "Thành lập công ty cổ phần & đầu tư công nghệ Bầu Trời Xanh",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="flex items-start w-full mb-6 last:mb-0 relative"
              >
                {index === 0 && (
                  <div className="absolute -top-3 left-10 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-[#1c9bdb]"></div>
                )}

                <div className="flex-shrink-0 w-[83px] h-[24px] bg-[#1c9bdb] text-[16px] rounded-full flex items-center justify-center text-white font-normal z-10">
                  {item.year}
                </div>

                {index !== 0 && (
                  <div className="absolute top-0 left-10 transform -translate-x-1/2 w-0.5 h-full bg-[#1c9bdb] z-0"></div>
                )}

                <div className="ml-4 text-[#1F1F1F] w-full text-[18px] font-normal">
                  {Array.isArray(item.text) ? (
                    item.text.map((line, lineIndex) => (
                      <p key={lineIndex} className="mb-2 last:mb-0">
                        {line}
                      </p>
                    ))
                  ) : (
                    <p>{item.text}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
